
angular.module("dyb.util.services", [
        'ui.router.util']);
